module.exports = "<chassis-auth-page-wrapper-component>\n    <p class=\"p-t-35\">{{'Logout' | translate}}</p>\n\n</chassis-auth-page-wrapper-component>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/authentication/pages/logout/logout.page.html
// module id = ./libs/chassis-core/src/app/authentication/pages/logout/logout.page.html
// module chunks = main